import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import ArrowButton from '../button-arrow';

const ArticleReadButton = ({link, textColor, category}) => (
  <div className="read-btn">
    <Link to={link}>
      <ArrowButton arrow={false} color={textColor} submit={false}>
        {
          category.name.toLowerCase() === 'about ignite' || category.name.toLowerCase() === 'how to earn' ?
            'Read More'
            :
            'Read Article'
        }
      </ArrowButton>
    </Link>
  </div>
);

ArticleReadButton.propTypes = {
  link: PropTypes.string,
  textColor: PropTypes.string,
  category: PropTypes.object
};

export default ArticleReadButton;
